const siteHeader = document.querySelector(".site-header");

export default {
  init: () => {
    const scrollPixel = document.querySelector(".scroll-pixel");

    if (scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }
  },
};
